import { useEffect, useState } from 'react';
import Spin from 'antd/lib/spin';
import { Redirect } from 'react-router-dom';
import AppLayout from 'components/AppLayout';
import { initInternalization } from 'localization/localization';
import {
	isInitialSetupCompleted,
	termsAndConditionsAccepted,
} from 'utils/userUtils';
import './styles/App.less';
import { useDispatch, useSelector } from 'react-redux';
import { isAdminSelector, userSelector } from 'redux/selectors/userSelector';
import { checkUserRole, getUserInfo } from 'redux/reducers/authenticationSlice';
import { ContentProviderAccountDto } from './api';
import { AppDispatch } from './redux/store';
import { useAuth0 } from '@auth0/auth0-react';
import flagsmith from 'flagsmith';
import { FlagsmithProvider } from 'flagsmith/react';

export default function App() {
	const [isLocaleInit, setIsLocaleInit] = useState(false);
	const { isLoading, user, getIdTokenClaims } = useAuth0();
	const userData = useSelector(userSelector);
	const isAdmin = useSelector(isAdminSelector);
	const dispatch: AppDispatch = useDispatch();
	
	useEffect(() => {
		const init = async () => {
			await initInternalization();
			if (!userData) {
				await dispatch(getUserInfo());
			}
			setIsLocaleInit(true);
		};
		init();
	}, [dispatch]);

	useEffect(() => {
		const getUserClaims = async () => {
			await dispatch(checkUserRole(getIdTokenClaims));
		};
		getUserClaims();
	}, [user]);

	const redirectUser = (userData: ContentProviderAccountDto | null) => {
		if (isAdmin) return false;
		if (window.location.pathname == '/test-invitation') {
			return false;
		}
		if (!userData || !userData.emailVerified) {
			return <Redirect to="email-verification" />;
		} else if (!termsAndConditionsAccepted(userData)) {
			return <Redirect to="/toc" />;
		} else if (!isInitialSetupCompleted(userData)) {
			return <Redirect to="/initial-setup" />;
		}
	};

	if (isLoading || !isLocaleInit) return <Spin />;

	return (
		<>
			<FlagsmithProvider
				options={{
					environmentID: process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY || '',
					api: process.env.REACT_APP_FLAGSMITH_API,
				}}
				flagsmith={flagsmith}
			>
				<AppLayout />
			</FlagsmithProvider>

			{(userData || user)  ? redirectUser(userData) : null}
		</>
	);
}
